export const HELP_DESK_SUPPORT_REQUESTS = '/support-requests'
export const HELP_DESK_REQUEST_MANAGEMENT = '/request-management'
